module.exports = __webpack_public_path__ + "img/teeth-41.e0fb7377.png";